async function sha256(input: string): Promise<string> {
  const data = new TextEncoder().encode(input);
  const hash = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(hash))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

export async function pushDataLayerEvent(
  event: string,
  email: string,
  ...parts: (string | number)[]
): Promise<void> {
  const win = window as unknown as { dataLayer?: Record<string, unknown>[] };
  if (!win.dataLayer) {
    win.dataLayer = [];
  }
  const dl = win.dataLayer;
  const seed = [event, email, ...parts].join(':');
  const eid = await sha256(seed);
  dl.push({ event, email, event_id: eid, eid });
}
